import { useClassName } from '@/styles/Adunit';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type AdunitWrapperProps = ComponentProps<'div'>;

export const AdunitWrapperComponent: Component<AdunitWrapperProps> = ({ children, ...props }) => {
  const className = useClassName('wrapper', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
